/**
 * Created by Макс on 01.11.2017.
 */
import { Component, ElementRef, Input } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Error } from '../class/broadcaster/app/error';
@Component({
    selector: 'dealer-upload-comp',
    templateUrl: 'upload-budget-file/index.html',
    styleUrls: ['add-access/bootstrap.min.css', 'add-access/update.css', 'add-access/style.css'], //left-menu/style.min.css
})
export class DealerUploadComponent {
    dealerShipId: number;
    dealerGroupId: number;
    preloader: boolean = false;
    currentMonth: any = window.localStorage.getItem('month') || new Date().getMonth() + 1;
    selectDate = { month: 0, year: 0 };
    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        this.selectDate.month = this.currentMonth;
        this.selectDate.year = new Date().getFullYear();
        let stage = this;
        $('#dateBudget').datepicker({
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
            dateFormat: 'MM yy',
            onClose: function (dateText, inst) {
                $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
                stage.selectDate.month = (inst.selectedMonth + 1);
                stage.selectDate.year = inst.selectedYear;
                // console.log("inst.selectedYear", inst.selectedYear);
                //  console.log("inst.selectedMonth", inst.selectedMonth);
            }
        });

        let data: any = JSON.parse(window.localStorage.getItem("dealerUpload"));
        // console.log("data", data);
        this.dealerGroupId = data.id;
        this.dealerShipId = data.rooftop;
        this.broadcaster.on<any>('rooftopsSelect').subscribe(data => {
            this.dealerShipId = data.id;
            // console.log("rooftopsSelect", this.dealerShipId);
        });
        this.broadcaster.on<any>('userId').subscribe(data => {
            this.dealerGroupId = data.id;
            //  console.log("userId", this.dealerGroupId);
        });
        document.querySelector("#file2").
            addEventListener('change', (event: any) => {
                let files = event.target.files; // FileList object
                if (files === null || files === undefined) {
                    return;
                }
                this.preloader = true;
                var formData = new FormData();

                formData.append("dealerShipId", String(this.dealerShipId));
                formData.append("year", String(this.selectDate.year));
                formData.append("month", String(this.selectDate.month + 1));

                // Файл, выбранный пользователем
                formData.append("uploadFile", files[0]);



                var request = new XMLHttpRequest();
                request.open("POST", `/api/budget/upload?id=${this.dealerGroupId}`);
                request.setRequestHeader('Accept', 'application/json');
                request.setRequestHeader('Authorization', 'Bearer ' + this.httpService.getAuthCookie());
                request.onload = () => {

                };
                request.onreadystatechange = (aEvt) => {
                    if (request.readyState == 4) {
                        $("#file2").val(null);
                        this.preloader = false;
                        if (request.status !== 200) {
                           
                            let Errors: any = JSON.parse(request.response);
                            this.broadcaster.broadcast(
                                'InfoError', new Error(Errors.errorName,Errors.errors)
                            );
                            //  console.log("e", request.response);
                        }
                        if (request.status === 200) {

                            alert("Budget file uploaded!!!");
                        }

                    }
                };

                request.send(formData);


                /*this.httpService.uploadBudget(fd, this.dealerShipId, this.dealerGroupId, year, month)
                    .subscribe(data => {
                        console.log('data', data);
                        if (data.data.saved === 1) {
                            event.target.value = null;
                            alert("Budget file uploaded!!!");
                        }

                    });*/
            }, false);
    }
    ShowDataPicker() {
        $("#dateBudget").datepicker("show");
        $('#ui-datepicker-div').css({ zIndex: 10 });
    }
    getDateString() {
        return `${(this.selectDate.month < 10) ? "0" + this.selectDate.month : this.selectDate.month}-01-${this.selectDate.year}`;
    }
    getDateMin(): string {
        return `${new Date().getFullYear()}-${(this.currentMonth < 10) ? "0" + this.currentMonth : this.currentMonth}-01`;
    }
    getDateMax(): string {
        return `${new Date().getFullYear()}-12-31`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-upload.component.ts